<p-dialog header="{{ 'ReceiptFormAssign.AssignGenerateReceipt' | translate }}" [(visible)]="isVisible" appendTo="body" (visibleChange)="dialogVisibleChange($event)"
  [modal]="true" [draggable]="false" [resizable]="false" [style]="{ width: '80%'  }">

  <form [formGroup]="assignForm">
    <div class="p-fluid mt-2">

      <div class="field grid">
          <label class="col-2"><span class="requiredStart">*</span> {{ 'ReceiptFormAssign.AssignWarehouse' | translate }}</label>
          <div class="col-10">
            <laas-facility-dropdown
              formControlName="facility"
              [divClass]="'p-text-left'"
              [isSingle]="true"
              [permissionCode]="facilityPermissionCode"
              (onOptionDataChange)="optionsDataOnChange($event, 'facility')">
            </laas-facility-dropdown>
          </div>
      </div>

      <div class="field grid">
        <label class="col-2"><span class="requiredStart">*</span>{{ 'ReceiptFormAssign.Forwarder' | translate }}</label>
        <div class="col-10">
            <p-dropdown formControlName="shipper" [(ngModel)]="assignWarehousingParams.shipper" [options]="bookingForwarderOptions"
                   optionLabel="optionDesc" optionValue="optionCode" [filter]="true"
                     placeholder="{{ 'Common.Message.ChooseOption' | translate }}" styleClass="p-text-left">
          </p-dropdown>
        </div>
      </div>

      <div class="field grid">
        <label class="col-2"><span class="requiredStart">*</span>{{ 'ReceiptFormAssign.DocumentType' | translate }}</label>
        <div class="col-10">
            <p-dropdown formControlName="deliveryType" [(ngModel)]="assignWarehousingParams.deliveryType" [options]="deliveryOptions"
                   optionLabel="label" optionValue="value" (onChange)="changeValidation()"
                     placeholder="{{ 'Common.Message.ChooseOption' | translate }}" styleClass="p-text-left">
          </p-dropdown>
        </div>
      </div>

      <div class="field grid">
        <label class="col-2"><span *ngIf="updateValidity(assignForm.controls.shipTerm)" class="requiredStart">*</span>{{ 'ReceiptFormAssign.TradeTerm' | translate }}</label>
        <div class="col-10">
            <p-dropdown formControlName="shipTerm" [(ngModel)]="assignWarehousingParams.shipTerm" [options]="shipTermOptions"
                   optionLabel="label" optionValue="value" [showClear]="true"
                   placeholder="{{ 'Common.Message.ChooseOption' | translate }}" styleClass="p-text-left">
          </p-dropdown>
        </div>
      </div>


      <div class="field grid">

        <label class="col-1"><span class="requiredStart">*</span>{{ 'ReceiptFormAssign.OriginCountry' | translate }}</label>
        <div class="col-3">
              <p-dropdown formControlName="fromCountry" [(ngModel)]="assignWarehousingParams.fromCountry" [options]="fromCountryOptions"
              (onChange)="changeCityOptions()" [filter]="true" appendTo="body"
              placeholder="{{ 'Common.Message.ChooseOption' | translate }}" styleClass="p-text-left">
            </p-dropdown>
        </div>

        <label class="col-1"><span class="requiredStart">*</span>{{ 'ReceiptFormAssign.OriginCity' | translate }}</label>
        <div class="col-3">
              <p-dropdown formControlName="fromCity" [(ngModel)]="assignWarehousingParams.fromCity" [options]="fromCityOptions" [showClear]="true"
              (onChange)="changeAreaOptions()" [filter]="true" appendTo="body"
              placeholder="{{ 'Common.Message.ChooseOption' | translate }}" styleClass="p-text-left">
            </p-dropdown>
        </div>


        <label class="col-1">{{ 'ReceiptFormAssign.OriginArea' | translate }}</label>
        <div class="col-3">
              <p-dropdown formControlName="fromArea" [(ngModel)]="assignWarehousingParams.fromArea" [options]="fromAreaOptions" [showClear]="true"
              [filter]="true" appendTo="body"
              placeholder="{{ 'Common.Message.ChooseOption' | translate }}" styleClass="p-text-left">
            </p-dropdown>
        </div>
      </div>

      <div class="field grid">
        <label class="col-2">{{ 'ReceiptFormAssign.CourierDeliveryCondition' | translate }}</label>
        <div class="col-4">
          <p-dropdown formControlName="expressTerm" [(ngModel)]="assignWarehousingParams.expressTerm" [options]="expressTermOptions" [showClear]="true"
             [filter]="true" [disabled]="!isExpressTermEdit" placeholder="{{ 'Common.Message.ChooseOption' | translate }}"  styleClass="p-text-left">
          </p-dropdown>
        </div>
      </div>

      <div class="field grid">
          <label class="col-2" ><span class="requiredStart">*</span>{{ 'ReceiptFormAssign.Supplier' | translate }}</label>
          <div class="col-4">
            <p-autoComplete formControlName="vendorCustomer" [(ngModel)]="assignWarehousingParams.vendorCustomer" [suggestions]="vendorSuggests" (completeMethod)="getVendorOptions($event)"></p-autoComplete>
          </div>
      </div>


      <div class="field grid">
        <label class="col-2" ><span class="requiredStart">*</span>{{ 'ReceiptFormAssign.CartonCnt' | translate }}</label>
        <div class="col-4">
          <p-inputNumber formControlName="totalCartonCnt" [(ngModel)]="assignWarehousingParams.totalCartonCnt"  ></p-inputNumber>
        </div>
      </div>

      <div class="field grid">
        <label class="col-2" >{{ 'ReceiptFormAssign.NumPallets' | translate }}</label>
        <div class="col-4">
          <p-inputNumber formControlName="palletCnt" ></p-inputNumber>
        </div>
      </div>

      <div class="field grid">
        <label class="col-2" >{{ 'ReceiptFormAssign.ReceivingTime' | translate }}</label>
        <div class="col-4">
          <laas-calendar
            #whDt
            [enableMaxDateIsToday]="false"
            [selectionMode]="'single'"
            [showCustomTime]="true"
            (onDateChange)="dateOnChange($event, 'whDt')">
          </laas-calendar>
        </div>
      </div>

      <div class="field grid">
        <label class="col-2" >{{ 'ReceiptFormAssign.GenerateExpenses' | translate }}</label>
        <div class="col-4">
          <p-dropdown formControlName="isGenerateFee" [(ngModel)]="assignWarehousingParams.isGenerateFee" [options]="yesNoOption"
            appendTo="body"
            placeholder="{{ 'Common.Message.ChooseOption' | translate }}" styleClass="p-text-left">
          </p-dropdown>
        </div>
      </div>
      <div class="field grid">
        <label class="col-2">{{ 'ReceiptFormAssign.CalculationUnit' | translate }}</label>
        <div class="col-4">
          <p-dropdown formControlName="uom" [(ngModel)]="assignWarehousingParams.uom" [options]="carTypeOptions" [showClear]="true"
             [filter]="true" placeholder="{{ 'Common.Message.ChooseOption' | translate }}"  styleClass="p-text-left">
          </p-dropdown>
        </div>
      </div>
    </div>


    <div class="mt-2 text-center">
      <button pRipple pButton label="{{ 'Common.Button.Confirm' | translate }}"
        (click)="confirmBtnClick($event)"></button>
      <button pRipple pButton label="{{ 'Common.Button.Cancel' | translate }}" class="p-button-secondary ml-2"
        (click)="cancelBtnClick($event)"></button>
    </div>
  </form>
</p-dialog>
